import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BlogPostTitleInterface } from 'common/types/entities/BlogPostTitleInterface'
import React from 'react'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import TextFontUpdater from '../components/Font/TextFontUpdater'
import {
  useUpdateEntity,
  useUpdateProp,
} from '../hooks/useUpdateProps'
import HtmlAttrId from '../options/HtmlAttrId'
import { AlignStyle, FontSize, LineHeight } from '../styles'

function BlogPostTitleSettingsNew({
  entity,
}: {
  entity: BlogPostTitleInterface
}) {
  const updateEntity = useUpdateEntity<BlogPostTitleInterface>()
  const updateProp = useUpdateProp(entity)

  const { isMobile } = useDeviceModeContext()

  return (
    <>
      <AlignStyle
        align={isMobile ? entity.mobileAlignSelf : entity.alignSelf}
        update={
          isMobile ? updateProp('mobileAlignSelf') : updateProp('alignSelf')
        }
        isFlex={false}
      />
      <LineHeight
        lineHeight={entity.lineHeight}
        mobileLineHeight={entity.mobileLineHeight}
        update={updateProp('lineHeight')}
        mobileUpdate={updateProp('mobileLineHeight')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <FontSize
        labelText="entity_settings.content_table.header_font_size"
        update={updateProp('fontSize')}
        mobileUpdate={updateProp('mobileFontSize')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <TextFontUpdater<BlogPostTitleInterface>
        entity={entity}
        update={updateEntity}
      />
      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={entity.color}
        mobileColor={entity.mobileColor}
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default BlogPostTitleSettingsNew
